import React, { Component } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal } from 'antd';
import './index.scss';

class ScissorImage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      src: null,
      loading: false,
    };
  }

  showModal = (file, callback) => {
    this.setState({ src: file, visible: true, loading: false });
    this.callback = callback;
  };

  hideModal = () => {
    this.callback = null;
    this.setState({ visible: false, src: null, loading: false });
    this.props.closeLoading && this.props.closeLoading();
  };

  // 下载图片
  handleDownload = () => {
    const img = document.createElement('a');
    img.href = this.state.src.replace('image/jpeg', 'image/octet-stream');
    const timestamp = Date.now();
    img.download = `带带-chat-${timestamp}.png`;
    img.click();

    this.callback && this.callback();
    this.hideModal();
  };

  render() {
    const { visible, src, loading } = this.state;
    return (
      <Modal
        title="截图"
        open={visible}
        width={700}
        wrapClassName="daidai-modal-style has-top-border"
        centered={true}
        keyboard={false}
        maskClosable={false}
        onCancel={this.hideModal}
        zIndex="1005"
        footer={[
          <button
            className="daidai-btn-primary"
            key="1"
            onClick={this.handleDownload}
            disabled={loading}
          >
            下载
          </button>,
        ]}
      >
        <div className="scissor-image-wrap">
          <img className="scissor-image" src={src} alt="截图" />
        </div>
      </Modal>
    );
  }
}

export default withRouter(ScissorImage, { withRef: true });
